import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getRevisedTraumaScoreSelector } from '../selectors'
import { RevisedTraumaScoreConstants } from '../store/revisedTraumaScore.constants'
import { setRTS } from '../store/revisedTraumaScore.actions'
import { IRevisedTraumaScoreState } from '../store/revisedTraumaScore.types'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'
import { IDataPointsConfig } from '../../../../configurations/store/configurations.types'
import { getGlassgowCommaScoreSelector } from '../../glassgowCommaScore/selectors'
import { IGlassgowCommaScoreState } from '../../glassgowCommaScore/store/glassgowCommaScore.types'
import { getTripInformationSelector } from '../../../../tripInformation/selectors'
import { GlassgowCommaScoreConstants } from '../../glassgowCommaScore/store/glassgowCommaScore.constants'

export function* calculateRevisedTraumaScore() {
  try {
    const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
    const revisedtricTraumaScoreData: IRevisedTraumaScoreState = yield select(getRevisedTraumaScoreSelector)
    const glassgowCommaScoreData: IGlassgowCommaScoreState = yield select(getGlassgowCommaScoreSelector)
    const tripInformationState: any = yield select(getTripInformationSelector)

    const { DP_RTSCALC } = datapointsConfig
    const { rtsBp, rtsResp } = revisedtricTraumaScoreData
    const { gcs } = glassgowCommaScoreData
    const { patientCategory } = tripInformationState
    const showRtsFlag = Boolean(patientCategory?.show_rts) ?? true
    if (rtsBp && rtsResp) {
      const validateTotal = (numberParamArr: any[]) => {
        let sum = 0
        let foundValidNumber = false
        numberParamArr.forEach((currentValue) => {
          if (typeof currentValue === 'number' && !isNaN(currentValue)) {
            sum += currentValue
            foundValidNumber = true
          }
        })

        return foundValidNumber ? sum : null
      }
      const gcsScore = gcs || 0
      let gcsCode = 0

      if (gcsScore > 12 && gcsScore < 16) {
        gcsCode = 4
      }
      if (gcsScore > 8 && gcsScore < 13) {
        gcsCode = 3
      }
      if (gcsScore > 5 && gcsScore < 9) {
        gcsCode = 2
      }
      if (gcsScore > 3 && gcsScore < 6) {
        gcsCode = 1
      }
      if (gcsScore < 4) {
        gcsCode = 0
      }
      if (DP_RTSCALC === 1 && showRtsFlag) {
        const gcsTemp = gcsCode * 0.9368
        const rtsBpTemp = (rtsBp?.id || 0) * 0.7326
        const rtsRestTemp = (rtsResp?.id || 0) * 0.2908
        const numberParamArr = [gcsTemp, rtsBpTemp, rtsRestTemp]
        const totalSore = validateTotal(numberParamArr)?.toFixed(3)
        yield put(setRTS(Number(totalSore)))
      } else {
        const numberParamArr = [gcsCode, rtsBp?.id, rtsResp?.id]
        const totalSore = validateTotal(numberParamArr)
        yield put(setRTS(totalSore))
      }
    }
  } catch (e) {
    yield put(throwPcrException(`calculateRevisedTraumaScore() error: ${e}`))
  }
}
export function* calculateRevisedTraumaScoreSaga() {
  yield takeLatest(
    [
      RevisedTraumaScoreConstants.SET_RTS_BP,
      RevisedTraumaScoreConstants.SET_RTS_RESP,
      RevisedTraumaScoreConstants.SET_RTS_DATA,
      GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE,
    ],
    calculateRevisedTraumaScore
  )
}
